<template>
    <div class="cms-container d-none d-xl-flex" :class="{ 'dimmed': showChangePasswordModal || showEditProfileModal }">

        <!-- CHANGE PASSWORD MODAL -->
        <div v-if="showChangePasswordModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Change Password</h2>
                    <button class="close-btn text-dark bg-transparent border-0" @click="closeModal">&times;</button>
                </div>
                <form class="modal-body mt-1" @submit.prevent="changePassword">

                    <!-- OLD PASSWORD INPUT -->
                    <div class="vmc-input-box w-100 mb-3 position-relative">
                        <span class="icon position-absolute" @click="toggleOldPassword">
                            <i v-if="showOldPassword" class="text-dark bi bi-eye-fill"></i>
                            <i v-else class="text-dark bi bi-eye-slash-fill"></i>
                        </span>
                        <input class="text-dark w-100 bg-transparent border-0"
                            :type="showOldPassword ? 'text' : 'password'" v-model="oldpassword" required>
                        <label class="position-absolute">Old Password</label>
                    </div>

                    <!-- NEW PASSWORD INPUT -->
                    <div class="vmc-input-box w-100 my-4 position-relative">
                        <span class="icon position-absolute" @click="toggleNewPassword">
                            <i v-if="showNewPassword" class="text-dark bi bi-eye-fill"></i>
                            <i v-else class="text-dark bi bi-eye-slash-fill"></i>
                        </span>
                        <input class="text-dark w-100 bg-transparent border-0"
                            :type="showNewPassword ? 'text' : 'password'" v-model="newpassword" required>
                        <label class="position-absolute">New Password</label>
                    </div>

                    <!-- CONFIRM NEW PASSWORD INPUT -->
                    <div class="vmc-input-box w-100 my-4 position-relative">
                        <span class="icon position-absolute" @click="toggleConfirmNewPassword">
                            <i v-if="showConfirmNewPassword" class="text-dark bi bi-eye-fill"></i>
                            <i v-else class="text-dark bi bi-eye-slash-fill"></i>
                        </span>
                        <input class="text-dark w-100 bg-transparent border-0"
                            :type="showConfirmNewPassword ? 'text' : 'password'" v-model="confirmnewpassword" required>
                        <label class="position-absolute">Confirm New Password</label>
                    </div>

                    <!-- ERROR MESSAGE -->
                    <p v-if="changePasswordError" class="text-danger text-center mb-2" style="font-size:0.85rem;">
                        {{ changePasswordError }}
                    </p>

                    <!-- FORM ACTIONS -->
                    <div class="modal-actions d-flex justify-content-end mt-3">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0"
                            :disabled="changePasswordLoading">
                            {{ changePasswordLoading ? 'Saving...' : 'Submit' }}
                        </button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- EDIT PROFILE MODAL -->
        <div v-if="showEditProfileModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Edit Profile</h2>
                    <button class="close-btn text-dark bg-transparent border-0" @click="closeModal">&times;</button>
                </div>
                <form class="modal-body" @submit.prevent="saveProfile">

                    <!-- PROFILE PHOTO UPLOAD -->
                    <div class="d-flex flex-column align-items-center mb-3">
                        <div class="position-relative">
                            <img :src="profile" alt="" id="profilePreview" class="rounded-circle"
                                style="width:110px; height:110px; object-fit:cover;">
                            <label for="profileImage"
                                class="select-photo material-symbols-outlined text-white p-2 rounded-circle vmc-bg-prime-5"
                                style="cursor:pointer; transition: 0.3s">
                                photo_camera
                            </label>
                            <input type="file" id="profileImage" accept="image/*" class="d-none"
                                @change="previewImage($event)">
                        </div>
                        <button type="button" class="mt-2 vmc-bg-prime-6 text-white border-0 rounded px-3 py-1"
                            @click="removeProfileImage($event)">
                            Remove Photo
                        </button>
                    </div>

                    <!-- ACCOUNT NAME INPUT -->
                    <div class="vmc-input-box mt-2 mb-4 position-relative">
                        <span class="icon position-absolute"><i class="text-dark bi bi-person-fill"></i></span>
                        <input class="text-dark w-100 bg-transparent border-0" type="text" v-model="editProfileName"
                            required>
                        <label class="position-absolute">Account Name</label>
                    </div>

                    <!-- PASSWORD INPUT -->
                    <div class="vmc-input-box w-100 mb-4 position-relative">
                        <span class="icon position-absolute" @click="togglePassword">
                            <i v-if="showPassword" class="text-dark bi bi-eye-fill"></i>
                            <i v-else class="text-dark bi bi-eye-slash-fill"></i>
                        </span>
                        <input class="text-dark w-100 bg-transparent border-0"
                            :type="showPassword ? 'text' : 'password'" v-model="password" required>
                        <label class="position-absolute">Password</label>
                    </div>

                    <!-- ERROR MESSAGE -->
                    <p v-if="editProfileError" class="text-danger text-center mb-2" style="font-size:0.85rem;">
                        {{ editProfileError }}
                    </p>

                    <!-- FORM ACTIONS -->
                    <div class="modal-actions d-flex justify-content-end mt-3">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0"
                            :disabled="editProfileLoading">
                            {{ editProfileLoading ? 'Saving...' : 'Submit' }}
                        </button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- TOP HEADER BAR -->
        <header class="d-xl-block fixed-top left-0">
            <nav class="w-100 d-flex align-items-center justify-content-between overflow-hidden">

                <!-- PAGE TITLE -->
                <h2 class="text-dark my-3 mx-3">{{ pageTitle }}</h2>

                <!-- PROFILE DROPDOWN TRIGGER -->
                <div class="vmc-profile-wrap my-3 mx-3 position-relative" ref="profileWrap">
                    <img :src="profile" alt="" class="vmc-profile-picture rounded-circle" @click="toggleDropdown">

                    <div class="vmc-profile">
                        <transition name="dropdown-slide">
                            <ul v-if="isDropdownOpen"
                                class="dropdown-menu dropdown-menu-end shadow show vmc-teleported-dropdown">

                                <!-- LOGGED IN USER INFO -->
                                <li class="px-3 py-2 d-flex align-items-center">
                                    <img :src="profile" class="rounded-circle mr-1" style="width:40px; height:40px;">
                                    <strong class="text-dark">{{ accountName }}</strong>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <!-- SETTINGS MENU ITEM WITH SUB-DROPDOWN -->
                                <li>
                                    <button
                                        class="dropdown-menu-items bg-transparent border-0 list-unstyled w-100 py-2 d-flex align-items-center px-3"
                                        @click="toggleSettings">
                                        <div class="icon-lists d-flex align-items-center text-dark mr-auto">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                                viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <path
                                                    d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
                                                <circle cx="12" cy="12" r="3" />
                                            </svg>
                                            <span
                                                style="font-size: 16px; margin-right:auto; color:#212529;">Settings</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                            viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-chevron-right-icon lucide-chevron-right"
                                            :class="{ 'rotate': isSettingsOpen }">
                                            <path d="m9 18 6-6-6-6" />
                                        </svg>
                                    </button>

                                    <!-- SETTINGS SUB-ITEMS -->
                                    <transition name="dropdown-slide">
                                        <ul v-if="isSettingsOpen" class="list-unstyled pb-2">
                                            <li>
                                                <button
                                                    class="open-settings-btn px-4 py-2 w-100 bg-transparent text-dark d-flex align-items-center border-0"
                                                    @click="openSettingsModal('password')">
                                                    <div class="icon-lists d-flex align-items-center text-dark">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                            viewBox="0 0 24 24" fill="none" stroke="#212529"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round">
                                                            <path
                                                                d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
                                                            <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
                                                        </svg>
                                                        Change Password
                                                    </div>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    class="open-settings-btn px-4 py-2 w-100 bg-transparent text-dark d-flex align-items-center border-0"
                                                    @click="openSettingsModal('profile')">
                                                    <div class="icon-lists d-flex align-items-center text-dark">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                            viewBox="0 0 24 24" fill="none" stroke="#212529"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round">
                                                            <path d="M18 20a6 6 0 0 0-12 0" />
                                                            <circle cx="12" cy="10" r="4" />
                                                            <circle cx="12" cy="12" r="10" />
                                                        </svg>
                                                        Edit Profile
                                                    </div>
                                                </button>
                                            </li>
                                        </ul>
                                    </transition>
                                </li>

                                <!-- LOGOUT BUTTON -->
                                <li>
                                    <button
                                        class="dropdown-menu-items text-decoration-none w-100 py-2 d-flex align-items-center px-3 bg-transparent border-0"
                                        @click="logout">
                                        <div class="icon-lists text-dark d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                                viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <path d="m16 17 5-5-5-5" />
                                                <path d="M21 12H9" />
                                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                            </svg>
                                            Logout
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
export default {
    name: "VMCHeaderCMS",

    data() {
        return {
            profile: require("@/assets/profile-black.png"),
            accountName: localStorage.getItem('vmc_user') || 'Account Name',
            password: '',
            oldpassword: '',
            newpassword: '',
            confirmnewpassword: '',
            showPassword: false,
            showOldPassword: false,
            showNewPassword: false,
            showConfirmNewPassword: false,
            showChangePasswordModal: false,
            showEditProfileModal: false,
            isDropdownOpen: false,
            isSettingsOpen: false,
            changePasswordError: '',
            changePasswordLoading: false,
            editProfileName: '',
            editProfileImage: '',
            editProfileError: '',
            editProfileLoading: false,
            tempProfileImage: null,
            overlayMouseDownOnOverlay: false,
        }
    },

    mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        window.addEventListener('profile-updated', this.loadProfile);
        document.addEventListener('click', this.closeDropdownOnOutside);
        this.loadProfile();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
        window.removeEventListener('profile-updated', this.loadProfile);
        document.removeEventListener('click', this.closeDropdownOnOutside);
    },

    computed: {
        pageTitle() {
            return this.$route.meta.title;
        }
    },

    watch: {
        '$route.meta.title': {
            immediate: true,
            handler(newTitle) {
                document.title = newTitle;
            }
        }
    },

    methods: {
        loadProfile() {
            const savedImage = localStorage.getItem(`vmc_profile_${this.accountName}`);
            if (savedImage) {
                this.profile = savedImage;
                const preview = document.getElementById('profilePreview');
                if (preview) preview.src = savedImage;
            } else {
                this.profile = require("@/assets/profile-black.png");
            }
        },

        resetForm() {
            this.password = '';
            this.oldpassword = '';
            this.newpassword = '';
            this.confirmnewpassword = '';
            this.showPassword = false;
            this.showOldPassword = false;
            this.showNewPassword = false;
            this.showConfirmNewPassword = false;
            this.changePasswordError = '';
            this.changePasswordLoading = false;
            this.editProfileName = '';
            this.editProfileImage = '';
            this.editProfileError = '';
            this.editProfileLoading = false;
            this.tempProfileImage = null;
        },

        togglePassword() { this.showPassword = !this.showPassword; },
        toggleOldPassword() { this.showOldPassword = !this.showOldPassword; },
        toggleNewPassword() { this.showNewPassword = !this.showNewPassword; },
        toggleConfirmNewPassword() { this.showConfirmNewPassword = !this.showConfirmNewPassword; },

        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
            this.isSettingsOpen = false;
        },

        toggleSettings() {
            this.isSettingsOpen = !this.isSettingsOpen;
        },

        closeDropdownOnOutside(e) {
            const wrap = this.$refs.profileWrap;
            if (this.isDropdownOpen && wrap && !wrap.contains(e.target)) {
                this.isDropdownOpen = false;
                this.isSettingsOpen = false;
            }
        },

        closeModal() {
            this.showChangePasswordModal = false;
            this.showEditProfileModal = false;
            this.resetForm();
            this.loadProfile();
        },

        openSettingsModal(type) {
            this.resetForm();
            this.loadProfile();
            if (type === 'password') this.showChangePasswordModal = true;
            if (type === 'profile') {
                this.showEditProfileModal = true;
                this.editProfileName = this.accountName;
            }
            this.isDropdownOpen = false;
            this.isSettingsOpen = false;
        },

        async changePassword() {
            if (!this.oldpassword || !this.newpassword || !this.confirmnewpassword) {
                this.changePasswordError = "Please fill in all fields.";
                return;
            }
            if (this.newpassword !== this.confirmnewpassword) {
                this.changePasswordError = "New passwords do not match.";
                return;
            }
            if (this.oldpassword === this.newpassword) {
                this.changePasswordError = "New password must be different from old password.";
                return;
            }

            this.changePasswordLoading = true;
            this.changePasswordError = '';

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/change-password`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        oldPassword: this.oldpassword,
                        newPassword: this.newpassword,
                    })
                });

                const data = await response.json();

                if (!response.ok) {
                    this.changePasswordError = data.message || "Failed to change password.";
                    return;
                }
                this.closeModal();
            } catch (error) {
                this.changePasswordError = "Could not connect to server.";
                console.error("Change password error:", error);
            } finally {
                this.changePasswordLoading = false;
            }
        },

        async saveProfile() {
            if (!this.password) {
                this.editProfileError = "Password is required to save changes.";
                return;
            }

            this.editProfileLoading = true;
            this.editProfileError = '';

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/edit-profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        newUsername: this.editProfileName,
                        password: this.password
                    })
                });

                const data = await response.json();

                if (!response.ok) {
                    this.editProfileError = data.message || "Incorrect password or server error.";
                    return;
                }

                const oldUsername = this.accountName;
                const newUsername = data.newUsername;

                localStorage.setItem('vmc_token', data.token);
                localStorage.setItem('vmc_user', newUsername);
                this.accountName = newUsername;

                if (this.tempProfileImage === 'REMOVE') {
                    localStorage.removeItem(`vmc_profile_${oldUsername}`);
                    localStorage.removeItem(`vmc_profile_${newUsername}`);
                } else if (this.tempProfileImage) {
                    localStorage.setItem(`vmc_profile_${newUsername}`, this.tempProfileImage);
                    if (oldUsername !== newUsername) localStorage.removeItem(`vmc_profile_${oldUsername}`);
                } else if (oldUsername !== newUsername) {
                    const existingImage = localStorage.getItem(`vmc_profile_${oldUsername}`);
                    if (existingImage) {
                        localStorage.setItem(`vmc_profile_${newUsername}`, existingImage);
                        localStorage.removeItem(`vmc_profile_${oldUsername}`);
                    }
                }

                this.loadProfile();
                window.dispatchEvent(new Event('profile-updated'));
                this.closeModal();

            } catch (error) {
                this.editProfileError = "Could not connect to server.";
            } finally {
                this.editProfileLoading = false;
            }
        },

        async previewImage(event) {
    const file = event.target.files[0];
    if (!file) return;

    // 1. INSTANT LOCAL PREVIEW (No Base64 required!)
    // This creates a temporary, lightweight local link just for the user's screen
    document.getElementById('profilePreview').src = URL.createObjectURL(file);

    // 2. PREPARE THE FILE FOR THE BACKEND
    const formData = new FormData();
    formData.append('image', file); 

    try {
        // 3. SILENTLY UPLOAD TO MULTER
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            // 4. SUCCESS! Save the SHORT LINK to your temporary state
            console.log("File uploaded, short link generated:", data.url);
            this.tempProfileImage = data.url; 
            
            // Now, when the user clicks your final "Save" button, 
            // 'this.tempProfileImage' only contains a tiny URL string!
        } else {
            console.error("Upload rejected:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
},

        removeProfileImage() {
            const profileImage = document.getElementById('profileImage');
            if (profileImage) profileImage.value = "";
            const defaultImg = require("@/assets/profile-black.png");

            document.getElementById('profilePreview').src = defaultImg;
            this.tempProfileImage = 'REMOVE';
        },

        logout() {
            localStorage.removeItem('vmc_token');
            localStorage.removeItem('vmc_user');
            this.$router.push('/auth/login');
        },

        onKeyboard(e) {
            if (e.key === 'Escape') {
                if (this.showChangePasswordModal || this.showEditProfileModal) {
                    this.closeModal();
                } else if (this.isDropdownOpen) {
                    this.isDropdownOpen = false;
                }
            }
        },

        onOverlayMouseDown(e) {
            this.overlayMouseDownOnOverlay = e.target.classList.contains('modal-overlay');
        },

        onOverlayMouseUp(e) {
            if (this.overlayMouseDownOnOverlay && e.target.classList.contains('modal-overlay')) {
                this.closeModal();
            }
            this.overlayMouseDownOnOverlay = false;
        },
    },
}
</script>

<style scoped>
/* BUTTON HOVER STATES */
.vmc-bg-prime-5:hover {
    background-color: var(--vmc-primary-7);
}

.vmc-bg-prime-4:hover {
    background-color: var(--vmc-primary-6);
}

/* DROPDOWN SLIDE DOWN ANIMATION */
.dropdown-slide-enter-active {
    animation: dropdownSlideDown 0.25s ease-out;
}

.dropdown-slide-leave-active {
    animation: dropdownSlideDown 0.2s ease-in reverse;
}

@keyframes dropdownSlideDown {
    from {
        transform: translateY(-10px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@media (min-width: 992px) {
    .cms-container {
        display: none;
    }
}

@media (min-width: 1200px) {

    .cms-container {
        margin-left: 310px;
    }

    .cms-container.dimmed {
        position: relative;
    }

    .cms-container.dimmed::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 2;
    }

    header {
        margin-left: 310px;
        z-index: 99;
        background-color: #e1e1e1;
        width: calc(100% - 310px);
    }

    .cms-container nav {
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .vmc-profile-picture {
        vertical-align: middle;
        width: 50px;
        height: 50px;
        cursor: pointer;
        object-fit: cover;
    }

    .dropdown-menu {
        max-width: 310px;
        width: 310px;
        position: absolute;
        right: 0;
        left: auto;
        margin-top: 10px;
        z-index: 1000;
    }

    .vmc-teleported-dropdown {
        position: fixed;
        top: 70px;
        right: 30px;
        z-index: 9999;
    }

    strong {
        font-size: 18px;
    }

    .dropdown-divider {
        height: 1px;
        border-width: 0;
        color: gray;
        background-color: gray;
    }

    .dropdown-menu-items {
        transition: 0.3s ease-in-out;
    }

    .icon-lists {
        gap: 5px;
    }

    .modal-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .modal-content {
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        animation: slideDown 0.3s ease-out;
    }

    .modal-header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
    }

    .modal-header h2 {
        font-size: 1.2rem;
    }

    .close-btn {
        font-size: 1.4rem;
        cursor: pointer;
    }

    .modal-body {
        padding: 20px;
    }

    .modal-actions {
        gap: 10px;
    }

    .vmc-input-box {
        border-bottom: 1px solid #000;
    }

    .vmc-input-box label {
        top: 50%;
        left: 2px;
        transform: translateY(-50%);
        font-size: 1em;
        pointer-events: none;
        transition: 0.3s;
    }

    .vmc-input-box input:focus~label,
    .vmc-input-box input:valid~label {
        top: -5px;
        font-size: 12px;
    }

    .vmc-input-box input {
        outline: none;
        height: 50px;
        font-size: 14px;
    }

    .vmc-input-box .icon {
        right: 8px;
        font-size: 1.2em;
        line-height: 50px;
    }

    .open-settings-btn {
        transition: 0.3s;
    }

    .dropdown-menu-items:hover,
    .open-settings-btn:hover {
        background-color: #f5f5f5 !important;
        cursor: pointer;
    }

    .lucide-chevron-right {
        transition: transform 0.2s ease;
        color: #212529;
    }

    .rotate {
        transform: rotate(90deg);
    }

    .select-photo {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
}
</style>